import { client } from './client';

export const ticketApi = {
  // lists
  getTicketListView: (params) => client.get('get_ticket_list_view', { params }),
  getMyContractStatus: () => client.get('get_my_contract_status'),
  getAssignedUnansweredTickets: () => client.get('get_assigned_unanswered_tickets'),
  getReferredOutTickets: () => client.get('get_referred_out_tickets'),
  getSimpleUserAll: () => client.get('get_simple_user_all_message'),
  getSimpleUserActive: () => client.get('get_simple_user_active_message'),
  getUserUnseen: (config) => client.get('get_user_unseen_message', config),
  getUserSeen: () => client.get('get_user_seen_message'),
  getUserUnresponsed: () => client.get('get_user_unresponsed_message'),
  getManagerUserAll: () => client.get('get_manager_user_all_message'),
  getManagerUserActive: () => client.get('get_manager_user_active_message'),
  getManagerUserUnseen: (config) => client.get('get_manager_user_unseen_message', config),
  getManagerUserSeen: () => client.get('get_manager_user_seen_message'),
  getManagerUserUnresponsed: () => client.get('get_manager_user_unresponsed_message'),
  getUnreadCount: () => client.get('get_unreaded_response_message', { _noRedirect: true }),
  getInboxNotifications: () => client.get('get_employee_inbox_notifications', { _noRedirect: true }),
  markInboxSeen: (data) => client.post('mark_employee_inbox_seen', data, { _noRedirect: true }),

  // detail
  getTicketInfo: (ticket_id) => client.get('get_ticket_info', { params: { ticket_id } }),
  getTicketSimpleInfo: (ticket_id) => client.get('get_ticket_simple_info', { params: { ticket_id } }),
  getTicketSmsTarget: (ticket_id) => client.get('get_ticket_sms_target', { params: { ticket_id } }),
  sendTicketSms: (ticket_id, message) => client.post('send_ticket_sms', { ticket_id, message }),
  getTicketBasicInfo: (ticket_id) => client.get('get_ticket_basic_info', { params: { ticket_id } }),
  getResponseSimpleInfo: (ticket_id) => client.get('get_response_simple_info', { params: { ticket_id } }),
  getTicketChatHistory: (ticket_id) => client.get('get_ticket_chat_history', { params: { ticket_id } }),
  getTicketResponseList: (ticket_id) => client.get('get_ticket_response_list', { params: { ticket_id } }),
  getTicketWithResponse: (ticket_id) => client.get('get_ticket_with_response', { params: { ticket_id } }),
  setUserSeenMessage: (ticket_id) => client.get('set_user_seen_message', { params: { ticket_id } }),

  // create / respond
  sendTicket: (data) => client.post('send_ticket', data),
  // dispatcher: bulk re-run AI routing on selected unrouted tickets (e.g.
  // after the AI service was briefly down and left them unassigned)
  aiRouteSelectedTickets: (ticket_ids) => client.post('ai_route_selected_tickets', { ticket_ids }),
  getTicketAiSummary: (data) => client.post('ticket_ai_summary', data),
  // Backend expects JSON {file_name, url (base64 data-URL), main_ticket_id}
  sendFile: (data) => client.post('send_file', data),
  deleteFileFromDraft: (params) => client.get('delete_file_from_draft', { params }),
  // type: 'ticket' (the ticket's own attachments) | 'dispatcher' | anything
  // else -> response attachments (see backend getFileList's dispatch)
  getFileList: (ticket_id, type = 'ticket') => client.get('get_file_list', { params: { ticket_id, type } }),
  getTicketDraft: (ticket_id) => client.get('get_ticket_draft', { params: { ticket_id } }),

  // employee response
  employeeSimpleSeenTicket: (params) => client.get('employee_simple_seen_ticket', { params }),
  employeeManagerSeenTicket: (params) => client.get('employee_manager_seen_ticket', { params }),
  getReferencingList: () => client.get('get_refrencing_list'),
  employeeReferencingTicket: (data) => client.post('employee_refrencing_ticket', data),
  employeeResponseTicket: (data) => client.post('employee_response_ticket', data),
  editResponseTicket: (data) => client.post('edit_response_ticket', data),
  /** After first reply is locked, send another support-side message (new chain ticket). */
  employeeFollowUpMessage: (data) => client.post('employee_followup_message', data),
  managerResponseTicket: (data) => client.post('manager_response_ticket', data),
  responseConfirmation: (params) => client.get('response_confirmation', { params }),

  // dispatcher
  getDepartmentsListForCompany: (company_name) =>
    client.get('get_departments_list_for_company', { params: { company_name } }),
  setTicketDepartment: (params) => client.get('set_ticket_department', { params }),
  // Dispatcher's own draft (description/priority/staged files) while
  // deciding which department(s) to assign a ticket to - separate table
  // from the customer-side ticket draft (dispatcher_draft/_files).
  getDispatcherDraft: (ticket_id) => client.get('get_dispatcher_draft', { params: { ticket_id } }),
  deleteDispatcherFileFromDraft: (params) => client.get('delete_dispatcher_file_from_draft', { params }),

  // user confirms the response (closes the ticket) or reopens it to continue
  deactivateTicket: (ticket_id) => client.get('deactivate_ticket', { params: { ticket_id } }),
  activateTicket: (ticket_id) => client.get('activate_ticket', { params: { ticket_id } }),

  // AI chat feedback (thumbs up auto-resolves the ticket)
  aiChatFeedback: (params) => client.get('ai_chat_feedback', { params }),

  // AI response assist (employee reply composer)
  // The ai_server's generate/improve/rewrite endpoints share one model and
  // can take 30-60s+ under load - the default 30s axios timeout would
  // abort a still-in-progress answer before the (now more patient) backend
  // even gets a chance to time out itself.
  generateAiResponse: (ticket_id) => client.get('generate_ai_response', { params: { ticket_id }, timeout: 115000 }),
  improveAiResponse: (params) => client.get('improve_ai_response', { params, timeout: 115000 }),
  rewriteAiResponse: (params) => client.get('rewrite_ai_response', { params, timeout: 115000 }),
  getAIResponseAssistLog: (ticket_id) => client.get('get_ai_response_assist_log', { params: { ticket_id } }),
};
